

const React = require("react");
require("./atoms.pc");
const {View: _b57e9bc7_IconView} = require("./icon.pc");

exports.classNames = {
};

const getDefault = (module) => module.default || module;

const addClass = (className, properties) => ({
  ...properties,
  className: properties.className ? properties.className + " " + className : className,
});

const castStyle = (value) => {
  const tov = typeof value;
  if (tov === "object" || tov !== "string") return value;
  return value.trim().split(";").reduce((obj, keyValue) => {
    const [key, value] = keyValue.split(":");
    if (!value || value === "undefined") return obj;
    const trimmedValue = value.trim();
    if (trimmedValue === "undefined") return obj;
    obj[key.trim()] = value && value.trim();
    return obj;
  }, {});
};

const getClassName = (className) => {
  return className ? className.split(" ").map(part => (
    "_b57e9bc7_" + part + " " +"_pub-b57e9bc7_" + part + " " +"_pub-11f16876_" + part + " " +part
  )).join(" ") : "";
};

const Error = React.memo(React.forwardRef(function Error(props, ref) {
  return React.createElement("div", {
      "ref": ref,
      "key": "3414b484",
      "className": "_3414b484 _b57e9bc7 _pub-b57e9bc7 _pub-11f16876 " + "_b57e9bc7_text-body-caption _pub-b57e9bc7_text-body-caption _pub-11f16876_text-body-caption text-body-caption",
    },
    React.createElement(_b57e9bc7_IconView, addClass("_a3ce56e4",{
        "key": "a3ce56e4",
      }),
    
    ),
    React.createElement("div", {
        className: "_4dc037c8 _b57e9bc7 _pub-b57e9bc7 _pub-11f16876", 
        "key": "4dc037c8",
      },
      (props.children)
    )
  );
}));
exports.Error = Error;

const View = React.memo(React.forwardRef(function View(props, ref) {
  return React.createElement("div", {
      "ref": ref,
      "key": "dd7711b1",
      "className":"" + "_dd7711b1 _b57e9bc7 _pub-b57e9bc7 _pub-11f16876 " + getClassName(props.className) + (props.compact ? " " + "_dd7711b1 _b57e9bc7 _pub-b57e9bc7 _pub-11f16876 " + "_b57e9bc7_compact _pub-b57e9bc7_compact _pub-11f16876_compact compact" : "") + (props.disabled ? " " + "_dd7711b1 _b57e9bc7 _pub-b57e9bc7 _pub-11f16876 " + "_b57e9bc7_disabled _pub-b57e9bc7_disabled _pub-11f16876_disabled disabled" : "") + (props.errorMessage ? " " + "_dd7711b1 _b57e9bc7 _pub-b57e9bc7 _pub-11f16876 " + "_b57e9bc7_error _pub-b57e9bc7_error _pub-11f16876_error error" : "") + (props.inline ? " " + "_dd7711b1 _b57e9bc7 _pub-b57e9bc7 _pub-11f16876 " + "_b57e9bc7_inline _pub-b57e9bc7_inline _pub-11f16876_inline inline" : ""),
    },
    React.createElement("label", {
        "key": "a7432a56",
        "className": "" + "_a7432a56 _b57e9bc7 _pub-b57e9bc7 _pub-11f16876 " + "_b57e9bc7_text-ui-small _pub-b57e9bc7_text-ui-small _pub-11f16876_text-ui-small text-ui-small" + (props.inline ? " " + "_a7432a56 _b57e9bc7 _pub-b57e9bc7 _pub-11f16876 " + "_b57e9bc7_text-body-paragraph-s _pub-b57e9bc7_text-body-paragraph-s _pub-11f16876_text-body-paragraph-s text-body-paragraph-s" : ""),
        "htmlFor": (props.for && (props.for)),
        "id": (props.labelId && (props.labelId)),
      },
      (props.label)
    ),
    (props.children),
    (props.errorMessage && (props.errorMessage)) && React.createElement(Error, {
        "ref": ref,
        "key": "44420a48",
      },
      (props.errorMessage)
    )
  );
}));
exports.View = View;

